import { LAYOUTS } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { authCAS, fetchMyPortfolio, goBack, goToFaq, goToKfs, goToStateSelectionPage, needHelp, onLoad, sendOtpForPledgeConfirm, triggerOtpForPledge, verifyPledgeOtp } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { ConfigTokens, getAppHeader } from '../../../configs/config';
import { getTotalLimit } from '../portfolio/actions';
import _ from 'lodash';
import { addCommasToNumber, getAutoDebitDate, getLenderInfo, getMinAllowedAmountBasedOnLender, horizontalStepperRepo } from '../../../configs/utils';
import { getDesiredValue } from '../portfolio_readonly/actions';
import { LENDER_ID } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isMobile } from "../../../configs/utils";
const _isMobile = isMobile();
export const template = async (totalAmount = 0, stepResponseObject, showOtpConfirmation = false, minAmount, maxAmount, showLessLimit = false, mfPortfolioArray, pledgeInProgress = false, term, interestRate, interestAmount, lenderInfo, autoDebitDate, user, stateDutyStamp, isTata, lenderId, isBajaj, height, stepper, showRefreshCriteria, pledgeOrder, percentage, creditLimit, isEnhancedLimit) => {
    return {
        layout: {
            id: ROUTE.ASSET_PLEDGE_V2,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "assetPledge", type: WIDGET.PLEDGE_SCREEN }
            ],
        },
        datastore: {
            assetPledge: {
                height: height,
                stepperData: stepper,
                continuePress: {
                    type: ACTION.TRIGGER_CAMS_FETCH,
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                },
                fetchKarvyAction: {
                    type: ACTION.TRIGGER_KARVY_FETCH,
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                    payload: {
                        assetRepository: 'KARVY'
                    }
                },
                bankCode: user.linkedBorrowerAccounts[0].accountHolderEmail,
                bankName: user.linkedBorrowerAccounts[0].accountHolderPhoneNumber,
                applyAction: {
                    type: ACTION.VERIFY_CAMS_FETCH,
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                },
                profileAction: {
                    type: ACTION.INIT_PLEDGE,
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                },
                addBankAction: {
                    type: ACTION.VERIFY_PLEDGE,
                    routeId: ROUTE.ASSET_PLEDGE_V2,
                },
                backAction: {
                    type: ACTION.GO_TO_KFS,
                    routeId: ROUTE.ASSET_PLEDGE_V2
                },
                skipBankAction: {
                    type: ACTION.BACK_BUTTON,
                    routeId: ROUTE.ASSET_PLEDGE_V2
                },
                sanctionedAmount: percentage,
                toBePledgedPortfolio: mfPortfolioArray,
                showRefreshCriteria: showRefreshCriteria,
                pledgingOrder: pledgeOrder,
                creditLimit: creditLimit,
                isEnhancedLimit: isEnhancedLimit
            },
        },
    };
};
export const assetPledge = {
    onLoad: async ({ instrumentTrack, network, setDatastore, getHeight }, { stepResponseObject, skipPledgeInProgressCheck = false }) => {
        let pledgeInProgress = skipPledgeInProgressCheck;
        let mfPortfolioArray = [];
        let portfolioForComputingProcessingCharge;
        const user = await SharedPropsService.getUser();
        let applicationId = "";
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const getPledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        const lenderId = getPledgeDetails?.data?.updatedApplicationObj?.lenderAccountId;
        const isTata = user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase();
        const isBajaj = user?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        let stateDutyStamp = '';
        instrumentTrack("LOAN_SUMMARY_PAGE_VIEWED", {
            "credit_limit": `${addCommasToNumber(await SharedPropsService.getCreditLimit())}`, "portfolio_pledge": `${addCommasToNumber(parseInt(await SharedPropsService.getDesiredPortfolio()))}`
        });
        // call pledge limit api if stepResponseObject is null
        let pledgeLimitResponse;
        if (stepResponseObject === undefined || stepResponseObject === null) {
            pledgeInProgress = !skipPledgeInProgressCheck;
            const authCAS = await SharedPropsService.getAuthCASResponse();
            pledgeLimitResponse = authCAS
                ? { data: authCAS }
                : await network
                    .get(`${api.pledgeLimit}${applicationId}`, {
                    headers: await getAppHeader(),
                })
                    .then(response => ({
                    data: response.data,
                }));
            stepResponseObject = pledgeLimitResponse.data.stepResponseObject;
        }
        if (!pledgeInProgress) {
            mfPortfolioArray = stepResponseObject
                .availableCAS;
            mfPortfolioArray.forEach((_item, index) => {
                mfPortfolioArray[index].is_pledged = _item.pledgedUnits > 0;
            });
            portfolioForComputingProcessingCharge = mfPortfolioArray;
        }
        else {
            mfPortfolioArray = stepResponseObject
                .tobePledgedPortfolio;
            portfolioForComputingProcessingCharge = [...mfPortfolioArray];
            portfolioForComputingProcessingCharge.push(...stepResponseObject.pledgedPortfolio);
        }
        await SharedPropsService.setToBePledgedAssets(mfPortfolioArray);
        /// fetch processing fee
        const stepper = await horizontalStepperRepo(network);
        let percentage = (getPledgeDetails.data.stepResponseObject.approvedCreditLimit / (getPledgeDetails.data.stepResponseObject.requestCreditLimit + getPledgeDetails.data.stepResponseObject.approvedCreditLimit)) * 100;
        if (Number.isNaN(percentage)) {
            percentage = 0;
        }
        const pledgeData = pledgeLimitResponse ? pledgeLimitResponse : await network.get(`${api.pledgeLimit}${applicationId}`, {
            headers: await getAppHeader(),
        });
        stateDutyStamp = pledgeData?.data?.stepResponseObject?.stampDutyState;
        const requestedCreditAmount = pledgeData?.data?.stepResponseObject?.requestedCreditAmount;
        if (requestedCreditAmount) {
            const stampDutyChargesResponse = await network.get(`${api.getStampDutyCharges}${requestedCreditAmount}`, {
                headers: await getAppHeader()
            });
            if (stampDutyChargesResponse.status === 200) {
                await sharedPropsService.setStampDutyData(stampDutyChargesResponse?.data);
            }
        }
        const portValue = getDesiredValue(mfPortfolioArray, stepResponseObject.isinNAVMap);
        const desiredLimit = getTotalLimit(mfPortfolioArray, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        const totalAmount = getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap);
        if (pledgeInProgress) {
            await SharedPropsService.setCreditLimit(desiredLimit);
        }
        const interestRate = _.get(pledgeData, 'data.stepResponseObject.interestRate');
        const term = _.get(pledgeData, 'data.stepResponseObject.loanTenureInMonths');
        await SharedPropsService.setDesiredPortfolio(portValue);
        const assetTypeMap = {};
        /*** check unique asset type */
        mfPortfolioArray.forEach(item => {
            if (item.is_pledged)
                assetTypeMap[item.assetRepository] = true;
        });
        /*** show 2 otp confirmation if both Karvy and CAMS is present */
        const showOtpConfirmation = Object.keys(assetTypeMap).length > 1;
        const minAmount = await SharedPropsService.getConfig(ConfigTokens.MIN_AMOUNT_ALLOWED);
        const maxAmount = await SharedPropsService.getConfig(ConfigTokens.MAX_AMOUNT_ALLOWED);
        let showLessLimit;
        if (!pledgeInProgress) {
            (await SharedPropsService.getCreditLimit()) < getMinAllowedAmountBasedOnLender(lenderId)
                ? (showLessLimit = true)
                : (showLessLimit = false);
        }
        const lenderInfo = await getLenderInfo(network);
        const interestAmount = Math.floor((10000 * interestRate) / 1200);
        const autoDebitDate = await getAutoDebitDate(network, lenderInfo);
        const isEnhancedLimit = await AsyncStorage.getItem("application_id") !== null && !(await SharedPropsService.getElevateFlow());
        return Promise.resolve(template(totalAmount, stepResponseObject, showOtpConfirmation, minAmount, maxAmount, showLessLimit, mfPortfolioArray, pledgeInProgress, term, interestRate, interestAmount, lenderInfo, autoDebitDate, user, stateDutyStamp, isTata, lenderId, isBajaj, getHeight(), stepper, true, getPledgeDetails.data.stepResponseObject.pendingOTPMap, percentage, getPledgeDetails.data.stepResponseObject.requestCreditLimit + getPledgeDetails.data.stepResponseObject.approvedCreditLimit, isEnhancedLimit));
    },
    actions: {
        [ACTION.NAV_TO_FAQ]: goToFaq,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.SEND_OTP_FOR_PLEDGE_CONFIRM]: sendOtpForPledgeConfirm,
        [ACTION.TRIGGER_CAMS_FETCH]: fetchMyPortfolio,
        [ACTION.TRIGGER_KARVY_FETCH]: fetchMyPortfolio,
        [ACTION.ON_PAGE_LOAD]: onLoad,
        [ACTION.GO_TO_KFS]: goToKfs,
        [ACTION.GO_TO_STATE_SELECTION_PAGE]: goToStateSelectionPage,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.VERIFY_CAMS_FETCH]: authCAS,
        [ACTION.INIT_PLEDGE]: triggerOtpForPledge,
        [ACTION.VERIFY_PLEDGE]: verifyPledgeOtp
    },
    action: {
        type: ACTION.ON_PAGE_LOAD,
        routeId: ROUTE.PLEDGE_CONFIRMATION,
        payload: {},
    },
    clearPrevious: true,
};
